module.exports = __webpack_public_path__ + "img/product24.000f5cca.png";